"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollItem = exports.scrollTop = exports.getUrlGetParams = exports.animationClass = exports.cleanFormValues = void 0;
const lodash_1 = __importDefault(require("lodash"));
const query_string_1 = __importDefault(require("query-string"));
const react_animations_1 = require("react-animations");
const aphrodite_1 = require("aphrodite");
__exportStar(require("./common"), exports);
const isEmptyString = (value) => {
    if (typeof value === 'string' && value.trim().length === 0) {
        return true;
    }
    return false;
};
const cleanFormValues = (data) => {
    const withoutHiddenItemsData = lodash_1.default.omitBy(data, (value, key) => lodash_1.default.startsWith(key, '_'));
    return lodash_1.default.mapValues(withoutHiddenItemsData, (value) => (value === '' || isEmptyString(value) ? null : value));
};
exports.cleanFormValues = cleanFormValues;
const animationClass = (name) => {
    const animations = {
        fadeIn: react_animations_1.fadeIn,
        fadeInDown: react_animations_1.fadeInDown,
        fadeInUp: react_animations_1.fadeInUp,
    };
    const style = aphrodite_1.StyleSheet.create({
        animation: {
            animationDuration: '1s',
            animationName: animations[name],
        },
    });
    return (0, aphrodite_1.css)(style.animation);
};
exports.animationClass = animationClass;
const getUrlGetParams = (input) => {
    const parsedData = query_string_1.default.parse(input);
    const output = {};
    lodash_1.default.forEach(parsedData, (value, key) => {
        if (Array.isArray(value)) {
            output[key] = value.join(';');
        }
        else {
            output[key] = value;
        }
    });
    return output;
};
exports.getUrlGetParams = getUrlGetParams;
const getScrollTopValue = (elementId, offset) => {
    let value = 0;
    if (document && elementId) {
        const element = document.getElementById(elementId);
        if (element) {
            value = element.offsetTop - (offset || 15);
        }
    }
    return value;
};
const scrollTop = (elementId, offset) => {
    if (window && window.scrollTo) {
        window.scrollTo({
            behavior: 'smooth',
            top: getScrollTopValue(elementId, offset),
        });
    }
};
exports.scrollTop = scrollTop;
const scrollItem = (itemId, elementId, offset) => {
    if (document) {
        const item = document.getElementById(itemId);
        const element = document.getElementById(elementId);
        if (item && element) {
            item.scroll({
                behavior: 'smooth',
                top: element.offsetTop + (offset || -50),
            });
        }
    }
};
exports.scrollItem = scrollItem;
